'use client';

import { LOTTERY_STATUS } from '@/constants';
import { SerialCodeFab as CommonSerialCodeFab } from '@monorepo/common';
import type { Session } from 'next-auth';
import { useIsOpenSerialCodeModal } from '../../state';

function SerialCodeFab({
  startAt,
  endAt,
  session = null,
  customOptions,
}: {
  startAt: string;
  endAt: string;
  session?: Session | null;
  customOptions?: { changeCampaignLotteryThesaurus?: string };
}) {
  const [_isOpenSCModal, setIsOpenSCModal] = useIsOpenSerialCodeModal();

  const openSerialCodeModal = () => {
    setIsOpenSCModal(true);
  };

  return (
    <CommonSerialCodeFab
      startAt={startAt}
      endAt={endAt}
      session={session}
      customOptions={customOptions}
      showSerialCodeNote={true}
      onOpenSerialCodeModal={openSerialCodeModal}
      lotteryStatus={LOTTERY_STATUS}
    />
  );
}

export default SerialCodeFab;
